// extracted by mini-css-extract-plugin
export default {"particles":"Home_particles__fIkvU","emailText":"Home_emailText__aWg7T"};